import React, { lazy } from "react";
const PaymentLoader = lazy(() => import("../Pages/Payment/PaymentLoader"));
const CheckOrder = lazy(() => import("../Pages/Order/CheckOrder"));
const HealthConcernList = lazy(() =>
  import("../Pages/CommonPages/HealthConcernList")
);
const ReDirectPath = lazy(() => import("../Pages/ReDirectPaths/ReDirectPath"));
const QualityAssured = lazy(() =>
  import("../Pages/CommonPages/QualityAssured")
);
const StoreImages = lazy(() => import("../Pages/Store/StoreImages"));
const StoreDetails = lazy(() => import("../Pages/Store/StoreDetails"));
const ViewByCategory = lazy(() =>
  import("../Pages/CommonPages/ViewByCategory")
);
const CustomerAllOrders = lazy(() => import("../Pages/Order/CustomerOrders"));
const CustomerCart = lazy(() =>
  import("../Pages/HamburgerOptions/CustomerCart")
);
const ProductDetails = lazy(() =>
  import("../Pages/CommonPages/ProductDetails")
);
const Wishlist = lazy(() => import("../Pages/HamburgerOptions/Wishlist"));
const PaymentStatus = lazy(() => import("../Pages/Payment/PaymentStatus"));
const ReturnsPage = lazy(() => import("../Pages/HamburgerOptions/ReturnsPage"));
const CurrentOrderDetails = lazy(() =>
  import("../Pages/CommonPages/CurrentOrderDetails")
);
const Faq = lazy(() => import("../Pages/CommonPages/Faq"));
const PrivacyPolicy = lazy(() => import("../Pages/CommonPages/PrivacyPolicy"));
const TAndC = lazy(() => import("../Pages/CommonPages/TAndC"));
const Login = lazy(() => import("../Pages/UserAuths/Login"));
const VerifyOtp = lazy(() => import("../Pages/UserAuths/VerifyOtp"));
const Search = lazy(() => import("../Pages/Search/Search"));

export const GlobalRoutes = [
  {
    name: "cart",
    path: "/cart-products",
    element: <CustomerCart />,
  },
  {
    name: "terms_and_conditions",
    path: "/terms-and-conditions",
    element: <TAndC />,
  },
  {
    name: "privacy_policy",
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    name: "faq",
    path: "/faq",
    element: <Faq />,
  },
  {
    name: "returns_and_cancellation_policy",
    path: "/returns-and-cancellation-policy",
    element: <ReturnsPage />,
  },

  {
    path: "/auth/login",
    element: <Login />,
  },
  {
    path: "/auth/verify-otp",
    element: <VerifyOtp />,
  },
  {
    name: "search",
    path: "/search",
    element: <Search />,
  },
  {
    name: "store_details",
    path: "/store-details",
    element: <StoreDetails />,
  },
  {
    name: "product_details",
    path: "/product-details/:name/:id",
    element: <ProductDetails />,
  },
  {
    name: "quality_assured",
    path: "/quality-assured",
    element: <QualityAssured />,
  },
  {
    name: "view-category",
    path: "/view-by-category",
    element: <ViewByCategory referrer={"category"} />,
  },
  {
    name: "view-by-category",
    path: "/type-details",
    element: <ViewByCategory referrer={"type_detail"} />,
  },
  {
    name: "health-concern-list",
    path: "/:hct_type/:hct_name/:hct_id",
    element: <HealthConcernList />,
  },
  {
    name: "store-images",
    path: "/store-images",
    element: <StoreImages />,
  },
  {
    name: "requestUrls",
    path: "/requestedUrl",
    element: <ReDirectPath />,
  },
  {
    name: "prescribeOrder",
    path: "/prescribe/:id",
    element: <CheckOrder referrer="prescribeOrder" />,
  },
  {
    name: "customOrder",
    path: "/custom-order/:id",
    element: <CheckOrder referrer="customOrder" />,
  },
  {
    name: "aCart",
    path: "/acart/:id",
    element: <CheckOrder referrer="aCart" />,
  },
];
export const ProtectRoutes = [
  {
    name: "customer_all_orders",
    path: "/customer/all-orders",
    element: <CustomerAllOrders />,
  },
  {
    name: "order_details",
    path: "/customer/order-detail",
    element: <CurrentOrderDetails />,
  },
  {
    name: "wishlist",
    path: "/wishlist",
    element: <Wishlist />,
  },
  {
    name: "payment_status",
    path: "/payment-success/:id",
    element: <PaymentStatus status="success" />,
  },
  {
    name: "payment_status",
    path: "/payment-failed/:id",
    element: <PaymentStatus status="failed" />,
  },
  {
    name: "payu-payment",
    path: "/payments/:id",
    element: <PaymentLoader />,
  },
];
